module.exports = __webpack_public_path__ + "111605bdddb75c037cbb2cd49bbbe779.glb";